class CartRecommendations extends HTMLElement {
    constructor() {
        super();
        this.grid = null;
        this.loader = null;
        this.cartProps = JSON.parse(document.querySelector('#cart-data').textContent);
        this.cartItemIds = [];
    }

    async connectedCallback() {
        this.renderSkeleton();
        this.showLoader();

        try {
            const cart = await this.fetchCart();

            if (!cart.items || cart.items.length < 1) {
                this.remove();
                return;
            }

            this.cartItemIds = cart.items.map(item => item.product_id);
            this.grid = this.querySelector('#recommended-products-grid');
            if (!this.grid) return;

            const allRecommendations = await this.fetchAllRecommendations(cart.items);

            if (allRecommendations.length === 0) {
                this.remove();
                return;
            }

            allRecommendations.forEach(productHtml => {
                this.grid.insertAdjacentHTML('beforeend', productHtml);
            });

            this.grid.addEventListener('click', this.handleAddToCartClick.bind(this));
            this.initSlider();
        } catch (error) {
            console.error('CartRecommendations error:', error);
        } finally {
            this.hideLoader();
        }
    }

    renderSkeleton() {
        this.innerHTML = `
        <div class="cart-recommendations__wrapper">
            <div class="cart-recommendations__header">
                <h2 class="h2">${this.cartProps.title}</h2>
                <div class="slider-control">
                    <button type="button" data-role="none" class="slick-prev slick-arrow" aria-label="Previous" role="button">Previous</button>
                    <button type="button" data-role="none" class="slick-next slick-arrow" aria-label="Next" role="button">Next</button>
                </div>
            </div>
            <div class="cart-recommendations__loader" hidden>
                <svg width="36" height="36" viewBox="0 0 24 24"><style>.spinner_EUy1{animation:spinner_grm3 1.2s infinite}.spinner_f6oS{animation-delay:.1s}.spinner_g3nX{animation-delay:.2s}.spinner_nvEs{animation-delay:.3s}.spinner_MaNM{animation-delay:.4s}.spinner_4nle{animation-delay:.5s}.spinner_ZETM{animation-delay:.6s}.spinner_HXuO{animation-delay:.7s}.spinner_YaQo{animation-delay:.8s}.spinner_GOx1{animation-delay:.9s}.spinner_4vv9{animation-delay:1s}.spinner_NTs9{animation-delay:1.1s}.spinner_auJJ{transform-origin:center;animation:spinner_T3O6 6s linear infinite}@keyframes spinner_grm3{0%,50%{animation-timing-function:cubic-bezier(.27,.42,.37,.99);r:1px}25%{animation-timing-function:cubic-bezier(.53,0,.61,.73);r:2px}}@keyframes spinner_T3O6{0%{transform:rotate(360deg)}100%{transform:rotate(0deg)}}</style><g class="spinner_auJJ"><circle class="spinner_EUy1" cx="12" cy="3" r="1"/><circle class="spinner_EUy1 spinner_f6oS" cx="16.50" cy="4.21" r="1"/><circle class="spinner_EUy1 spinner_NTs9" cx="7.50" cy="4.21" r="1"/><circle class="spinner_EUy1 spinner_g3nX" cx="19.79" cy="7.50" r="1"/><circle class="spinner_EUy1 spinner_4vv9" cx="4.21" cy="7.50" r="1"/><circle class="spinner_EUy1 spinner_nvEs" cx="21.00" cy="12.00" r="1"/><circle class="spinner_EUy1 spinner_GOx1" cx="3.00" cy="12.00" r="1"/><circle class="spinner_EUy1 spinner_MaNM" cx="19.79" cy="16.50" r="1"/><circle class="spinner_EUy1 spinner_YaQo" cx="4.21" cy="16.50" r="1"/><circle class="spinner_EUy1 spinner_4nle" cx="16.50" cy="19.79" r="1"/><circle class="spinner_EUy1 spinner_HXuO" cx="7.50" cy="19.79" r="1"/><circle class="spinner_EUy1 spinner_ZETM" cx="12" cy="21" r="1"/></g></svg>
            </div>
            <div class="cart-recommendations__list" id="recommended-products-grid"></div>
        </div>
      `;
    }

    showLoader() {
        this.loader = this.querySelector('.cart-recommendations__loader');
        if (this.loader) {
            this.loader.hidden = false;
        }
    }

    hideLoader() {
        if (this.loader) {
            this.loader.hidden = true;
        }
    }

    async fetchCart() {
        const response = await fetch('/cart.js');
        return await response.json();
    }

    async fetchAllRecommendations(cartItems) {
        const shownProductIds = new Set(this.cartItemIds);
        const allProducts = [];

        const promises = cartItems.map(item =>
            fetch(`/recommendations/products.json?product_id=${item.product_id}&limit=6`)
                .then(res => res.json())
                .then(data => data.products || [])
                .catch(err => {
                    console.error('Recommendation error:', err);
                    return [];
                })
        );

        const results = await Promise.all(promises);

        results.flat().forEach(product => {
            if (shownProductIds.has(product.id)) return;
            shownProductIds.add(product.id);

            const productHtml = `
                <div class="cart-recommendations__list-item">
                    <div class="list-item__card">
                    <a href="${product.url}" class="list-item__media">
                        <img src="${product.featured_image}&width=150" alt="${product.title}" loading="lazy">
                    </a>
                    <div class="list-item__content">
                        <h3>${product.title}</h3>
                        <div class="list-item__cta">
                            <button class="add-to-cart-button" data-variant-id="${product.variants[0].id}">
                                ${this.cartProps.button_title} - ${this.cartProps.currency}${(product.price / 100).toFixed(2)}
                            </button>
                        </div>
                    </div>
                    </div>
                </div>
            `;
            allProducts.push(productHtml);
        });

        return allProducts;
    }

    handleAddToCartClick(event) {
        const button = event.target.closest('.add-to-cart-button');
        if (!button) return;
    
        const variantId = button.dataset.variantId;
        if (!variantId) return;
    
        fetch('/cart/add.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                id: variantId,
                quantity: 1
            })
        })
        .then(response => {
            if (!response.ok) throw new Error('Network response was not ok');
            return response.json();
        })
        .then(() => {
            return fetch('/?sections=cart-drawer,cart-icon-bubble');
        })
        .then(response => response.json())
        .then(parsedState => {
            const cartDrawer = document.querySelector('cart-drawer');
            if (cartDrawer) {
                cartDrawer.renderContents({
                    sections: parsedState
                });
            }
        })
        .catch(error => {
            console.error('Error adding item to cart:', error);
        });
    }
    

    initSlider() {
        if (!this.grid) return;

        const itemCount = this.grid.querySelectorAll('.cart-recommendations__list-item').length;
        if (itemCount <= 1) {
            return;
        }

        $(this.grid).slick({
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: true,
            prevArrow: $('.cart-recommendations__wrapper .slick-prev'),
            nextArrow: $('.cart-recommendations__wrapper .slick-next')
        });
    }
}

customElements.define('cart-recommendations', CartRecommendations);
